import "./footer.scss";

export default function Footer() {
  return (
    <div className="footer">
      <p className="footer-text">Privacy Policy | Terms of Service</p>
    </div>
  );
}
